export const AutoCheckFeedbackItemBaseFragment = gql`
  fragment AutoCheckFeedbackItemBaseFragment on AutoCheckFeedbackItemBase {
    id
    feedbackText
    severity
    sourceRuleType
    createdAt
    resolvedAt
  }
`

export const AutoCheckFeedbackItemFragment = gql`
  fragment AutoCheckFeedbackItemFragment on AutoCheckFeedbackItem {
    id
    createdAt
    feedbackText
    markedAsNotApplicableAt
    reasonWhyMarkedAsNotApplicable
    resolvedAt
    severity
    sourceRuleType
    status
    codeBookItem {
      ...CodeBookItemFragment
    }
    markedAsNotApplicableByUser {
      ...UserDataFragment
    }
    resolvedByUser {
      ...UserDataFragment
    }
  }
`

export const PlanReviewAutoCheckFeedbackItemFragment = gql`
  fragment PlanReviewAutoCheckFeedbackItemFragment on AutoCheckFeedbackItem {
    ...AutoCheckFeedbackItemFragment
    codeBookItem {
      ...CodeBookItemOptionFragment
    }
  }
`

export const AutoCheckExecutionFragment = gql`
  fragment AutoCheckExecutionFragment on AutoCheckExecution {
    id
    autoCheckFeedbackItems {
      ...AutoCheckFeedbackItemFragment
    }
  }
`

export const AutoCheckFeedbackUpdateFragment = gql`
  fragment AutoCheckFeedbackUpdateFragment on AutoCheckFeedbackUpdate {
    executionId
    isDone
    feedback {
      ...AutoCheckFeedbackItemBaseFragment
    }
  }
`
